import { CheckInResultInt } from "@app/interfaces/passenger.interface";
import { Reservation } from "@app/models";
export class PassengerMapper {

  private checkinResult: CheckInResultInt = {};

  constructor() {}
  checkIn(response: any,reservations: Reservation[]) {
    const reservation = reservations[0]

    if (response._warnings && response._warnings._collection && response._warnings._collection.length &&
      response._warnings._collection.length > 0) {
      if (response._warnings._collection[0].msg) {
        this.checkinResult.warnings = []
        this.checkinResult.warnings.push(response._warnings._collection[0]);
      }
    }

    this.checkinResult.mustOfferOverbooking = response.mustOfferOverbooking;
    this.checkinResult.boardingPasses = []
    this.checkinResult.notOkToBoard = [];

    let checkedInCarts = response.checkedInCarts._collection;
    if (checkedInCarts && checkedInCarts.length && checkedInCarts.length > 0) {
      for (let cartIndex = 0; cartIndex < checkedInCarts.length; cartIndex++) {
        let checkedInCart = checkedInCarts[cartIndex];

        let paymentLinkedList = checkedInCart.paymentLinkedList;
        if (paymentLinkedList && paymentLinkedList.length && paymentLinkedList.length > 0) {
          let authResult = paymentLinkedList[0].authorizationResult;
          if (authResult.responseCode == "APPROVED") {
            this.checkinResult.paymentResponseCode = "1";
          } else {
            this.checkinResult.paymentResponseCode = "2";
          }
          this.checkinResult.responseCode = authResult.responseCode;
        }
        let pectabBoardingPassList = checkedInCart.pectabBoardingPassList;
        if (pectabBoardingPassList && pectabBoardingPassList.length) {
          this.checkinResult.boardingPassPrinterInit = pectabBoardingPassList[0].value;
        }

        let pectabReceiptList = checkedInCart.pectabReceiptList;
        if (pectabReceiptList && pectabReceiptList.length) {
          this.checkinResult.receiptPrinterInit = pectabReceiptList[0].pectab;
          this.checkinResult.receipt = pectabReceiptList[0].receipt;
        }

        let travelerInfoList = checkedInCart.travelerInfo;
        if (travelerInfoList && travelerInfoList._collection && travelerInfoList._collection.length) {
          for (let index = 0; index < travelerInfoList._collection.length; index++) {
            let travelerInfo = travelerInfoList._collection[index];
            let segmentDocumentsList = travelerInfo.segmentDocumentsList;
            if (segmentDocumentsList && segmentDocumentsList.length) {
              for (let docIndex = 0; docIndex < segmentDocumentsList.length; docIndex++) {
                let segmentDocument = segmentDocumentsList[docIndex];
                this.checkinResult.boardingPasses.push(segmentDocument.travelDoc);
              }
            }

            if (travelerInfo && travelerInfo.timaticInfo && travelerInfo.timaticInfo.status && travelerInfo.timaticInfo.status === 'NOT OK TO BOARD') {
              this.checkinResult.notOkToBoard.push(travelerInfo);
            }
            if (travelerInfo.infant) {
              let segmentDocumentsList = travelerInfo.infant.segmentDocumentsList;
              if (segmentDocumentsList && segmentDocumentsList.length) {
                for (let docIndex = 0; docIndex < segmentDocumentsList.length; docIndex++) {
                  let segmentDocument = segmentDocumentsList[docIndex];
                  this.checkinResult.boardingPasses.push(segmentDocument.travelDoc);
                }
              }
            }

            if (this.checkinResult.mustOfferOverbooking) {
              for (let passengerIndex = 0; passengerIndex < reservation.passengers.length; passengerIndex++) {
                let passenger = reservation.passengers[passengerIndex];
                if (passenger.id == travelerInfo.id) {
                  passenger.isOverBookingEligible = travelerInfo.isOverBookingEligible;
                  break;
                }
              }
            }
          }
        }
      }
    }

    if (response.dailyForecasts) {
      this.checkinResult.weatherInfo = {};
      this.checkinResult.weatherInfo.unit = response.dailyForecasts.Temperature.Minimum.Unit;
      this.checkinResult.weatherInfo.minTemp = response.dailyForecasts.Temperature.Minimum.Value;
      this.checkinResult.weatherInfo.maxTemp = response.dailyForecasts.Temperature.Maximum.Value;
      this.checkinResult.weatherInfo.dayIcon = response.dailyForecasts.Day.Icon;
      this.checkinResult.weatherInfo.nightIcon = response.dailyForecasts.Night.Icon;
    }

    if(response.issuedBagTags){
      this.checkinResult.issuedBagTags = response.issuedBagTags[0];
    }

    return this.checkinResult;
  }
}
